import { render, staticRenderFns } from "./customerAgedBalanceChartWidget.vue?vue&type=template&id=337bdbbc&"
import script from "./customerAgedBalanceChartWidget.vue?vue&type=script&lang=js&"
export * from "./customerAgedBalanceChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports